export default "__VITE_ASSET__BjfFBadC__"